import React from "react";

import classNames from "classnames";
import PropTypes from "prop-types";

import { ReactComponent as IconDelete18 } from "../../icons/icon/18/a-icon-delete-18.svg";

import "./filterTag.scss";

const FilterTag = ({
  children,
  icon = <IconDelete18 />,
  onClick = null,
  variant = "primary",
}) => (
  <div
    className={classNames(
      "filter-tag",
      variant && `filter-tag--${variant}`,
      { "filter-tag--action": onClick !== null },
    )}
  >
    {children}
    {React.cloneElement(icon, { onClick })}
  </div>
);

FilterTag.propTypes = {
  children: PropTypes.node.isRequired,
  icon: PropTypes.oneOfType([PropTypes.object]),
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(["primary", "events", "article-teaser"]),
};

export default FilterTag;
